import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import { injectStripe } from 'react-stripe-elements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { connect } from "react-redux";
import { showAlert } from '../store/actions/alert';
import {convertReadbleFormat} from './../helpers';
import Card from './card'
import { COLORS } from './../styles/colors';

const $ = window.$;

const freedownload = "#freedownload";
class Register extends Component {

  constructor(props) {
    super(props);

    this.validator = new ReeValidate({
      email: 'required|email',
      password: 'required|min:3',
      lastName: 'required',
      firstName: 'required',
    });
    this.state = {
      formData: {
        email: '',
        password: '',
        lastName: '',
        firstName: '',
        cardHolderName: ''
      },
      formErrors: this.validator.errors,
      isSubmit: false,
      isRevealPwd: false,
    };
    this.paymentCard = React.createRef();

  }

  componentDidMount() {
    $(freedownload).on('hidden.bs.modal', () => {
      this.closeModal();
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    const { removeError } = this.props;
    removeError();
    const { formData } = this.state;
    const { errors } = this.validator;
    this.paymentCard.current.getWrappedInstance().handleSubmit()
    const paymentCardInstance = this.paymentCard.current.getWrappedInstance();
    const { isCardError, cardHolderName } = paymentCardInstance.state;
    this.validator.validateAll(formData).then(success => {
      if (success) {
        if (isCardError) {
          this.setState({
            isSubmit: true,
          });
          this.createNonce({ ...formData, email: formData.email.toLowerCase(), cardHolderName: cardHolderName });
        }
      } else {
        this.setState({ formErrors: errors });
      }
    });
  };

  async createNonce(formData) {
    // Send the nonce to your server
    const cardHolderName = formData.cardHolderName;
    const { showAlert } = this.props;
    const res = await this.props.stripe.createToken({ name: cardHolderName });
    if (res.error) {
      const message = res.error.message;
      showAlert(message, true);
      this.setState({
        isSubmit: false,
      });
    } else {
      const token = res.token;
      this.props
      .onAuth('signup', {
        ...formData,
        token: token.id,
        type: 'trainer'
      })
      .then(response => {
        this.setState({
          isSubmit: false,
        });
        $(freedownload).modal('hide');
      }).catch(error =>{
        this.setState({
          isSubmit: false,
        });
      });
    }
  }

  handleChange = e => {
    const elementName = e.target.name;
    const elementValue = e.target.value;
    const { errors } = this.validator;
    errors.remove(elementName);
    this.setState({ formData: { ...this.state.formData, [elementName]: elementValue } });
    this.validator.validate(elementName, elementValue).then(() => {
      this.setState({ formErrors: errors });
    });
  };

  toggleVisiblePassword() {
    this.setState({
      isRevealPwd: !this.state.isRevealPwd
    })
  }

  closeModal = () => {
    this.validator.errors.clear();
    this.paymentCard.current.getWrappedInstance().clearFields();
    this.props.removeError();
    this.setState(
      {
        formData: {
          email: '',
          password: '',
          lastName: '',
          firstName: '',
          cardHolderName: ''
        },
        formErrors: this.validator.errors,
        isPaymentButtonDisable: true,
        isSubmit: false,
        isRevealPwd: false
      },
      () => $(freedownload).modal('hide')
    );
  };

  render() {

    const { formData, formErrors, isSubmit, isRevealPwd } = this.state;
    const { errors } = this.props;

    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={this.closeModal}>
              &times;
            </button>
            <h3>&nbsp;</h3>
          </div>
          <div style={{ padding: '50px' }} className="modal-body">
            <div className="row">
              <div className="col-md-6">
                <h3>
                  Fitbanx is the easy way for trainers, coaches, and fitness
                  brands to build and share workouts.
                </h3>
                <ul>
                  <li>14 day free trial, then only $39 per month</li>
                  <li>
                    Cancel before the end of the free trial and you won’t be
                    billed
                  </li>
                  <li>
                    Enter the digital marketplace, increase profits, and create
                    recurring monthly revenue
                  </li>
                  <li>60-day money back guarantee</li>
                </ul>
              </div>
              <div className="col-md-6">
                {errors && errors.message && (
                  <div className="alert alert-danger">{errors.message}</div>
                )}
                <form onSubmit={this.handleSubmit} noValidate>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Sign up email:</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Enter email"
                          name="email"
                          onChange={this.handleChange}
                          required
                          value={formData.email}
                        />
                        {formErrors.has('email') && (
                          <span className="error text-danger">
                            {convertReadbleFormat(formErrors.first('email'))}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group" style={{
                      position: 'relative'
                    }}>
                        <label htmlFor="lname">Create password:</label>
                        <input
                          type={isRevealPwd ? "text" : "password"}
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Enter password"
                          onChange={this.handleChange}
                          required
                          value={formData.password}
                        />
                        <FontAwesomeIcon icon={ isRevealPwd ? faEyeSlash : faEye} title={'toggle'}
								          style={{
                            marginRight: '5px',
                            position: 'absolute',
                            right: '10px',
                            top: '48px',
                            color: COLORS.orange,
                            zIndex: '99999'
                          }}
                          onClick = {() => this.toggleVisiblePassword(false)} 
                      />
                        {formErrors.has('password') && (
                          <span className="error text-danger">
                            {convertReadbleFormat(formErrors.first('password'))}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <p>
                        <em>
                          You will not be charged until after your 14 day free
                          trial.
                        </em>
                      </p>
                    </div>


                  <Card  ref={this.paymentCard}  brandIcon="brand-icon"></Card>

                  </div>


                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="firstName"
                          placeholder="First name"
                          name="firstName"
                          onChange={this.handleChange}
                          required
                          value={formData.firstName}
                        />
                        {formErrors.has('firstName') && (
                          <span className="error text-danger">
                            {convertReadbleFormat(formErrors.first('firstName'))}
                          </span>
                        )}
                      </div>
                    </div>
                    
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="lastName"
                          placeholder="Last name"
                          name="lastName"
                          onChange={this.handleChange}
                          required
                          value={formData.lastName}
                        />
                        {formErrors.has('lastName') && (
                          <span className="error text-danger">
                            {convertReadbleFormat(formErrors.first('lastName'))}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        type="submit"
                        className="btn circle btn-light border btn-md"
                        disabled={isSubmit}
                      >
                        Finish
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={this.closeModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
      paymentToken: state.payments.token
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      showAlert: (message, isError) => {
        return dispatch(showAlert(message, isError));
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(injectStripe(Register));



// WEBPACK FOOTER //
// ./src/modals/register.js